import { registerQuery, registerMutation } from 'data-fetching-client';
import PortalIdParser from 'PortalIdParser';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
const usersClient = promiseClient(createStack(coreMiddlewares.base('users/v2/'), appAuthStack));
export const GET_ADMINS = registerQuery({
  fieldName: 'admins',
  args: [],
  fetcher: async () => {
    const PORTAL_ID = PortalIdParser.get();
    try {
      // First get deactivated users to filter them out
      const deactivatedUsers = await usersClient.get(`app/scopes/deactivated/hubs/${PORTAL_ID}/hub-users`);
      const deactivatedUserIds = deactivatedUsers.map(user => user.id);

      // Then get super admins
      const allAdmins = await usersClient.get(`app/scopes/super-admin/hubs/${PORTAL_ID}/hub-users`);

      // Filter out deactivated users
      const activeAdmins = allAdmins.filter(admin => {
        return !deactivatedUserIds.includes(admin.id);
      });
      return activeAdmins;
    } catch (error) {
      console.error('Error fetching admins:', error);
      throw error;
    }
  }
});
export const SEND_ADMIN_EMAIL = registerMutation({
  fieldName: 'sendAdminEmail',
  args: ['adminUserId', 'listingId', 'adminInstall', 'permissions'],
  fetcher: async ({
    adminUserId,
    listingId,
    adminInstall = false,
    permissions = []
  }) => {
    const ecosystemClient = getEcosystemClient('app');
    const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
    const data = adminInstall ? {
      adminUserId,
      listingId
    } : {
      adminUserId,
      listingId,
      permissions
    };
    try {
      await ecosystemClient.post(endpoint, {
        data
      });
      return {
        success: true
      };
    } catch (error) {
      console.error('Error sending admin email:', error);
      throw error;
    }
  }
});

// Legacy wrapper function for backward compatibility
export const sendAdminEmail = async (adminUserId, listingId, adminInstall = false, permissions = []) => {
  const ecosystemClient = getEcosystemClient('app');
  const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
  const data = adminInstall ? {
    adminUserId,
    listingId
  } : {
    adminUserId,
    listingId,
    permissions
  };
  try {
    await ecosystemClient.post(endpoint, {
      data
    });
  } catch (error) {
    console.error('Error sending admin email:', error);
    throw error;
  }
};